import React, {Component} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ModalButton extends Component{
    constructor(props) {
        super(props)
        this.state = {
          modal: false
        }
      }
    
      toggle = () => {
        this.setState({modal: !this.state.modal})
      }

      cancel = () => {
        if(this.props.cancel)
          return this.props.cancel(this.toggle)
        
        this.toggle()
      }
    
      render() {
        return (
          <div>
            <Button active block color={this.props.color} type={this.props.type} aria-pressed="true"onClick={this.toggle}>{this.props.buttonLabel}</Button>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} autoFocus={false}>
              <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
              <ModalBody>
                {this.props.children}
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={() => this.props.confirm(this.toggle)}>Confirmar</Button>{' '}
                <Button color="secondary" onClick={this.cancel}>Cancelar</Button>
              </ModalFooter>
            </Modal>
          </div>
        );
      }
}

export default ModalButton;


// WEBPACK FOOTER //
// ./src/views/components/modal-button/ModalButton.js